import Button from "../layout/Button"

export default function ContactUsBanner() {
  return (
    <div className="bg-yellow py-12 sm:py-20 relative">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 grid grid-cols-1 sm:grid-cols-2 justify-center gap-4 md:gap-x-20">

        {/* Text content */}
        <div className="grid grid-cols-1 gap-y-4">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-semibold text-dark-grey">Get in touch</h1>
          <p className="text-dark-grey text-sm sm:text-base lg:text-xl font-medium">
            Want to bring Alexandra's inspirational energy and expertise to your event or organisation?
          </p>
        </div>

        {/* Form */}
        <div className="grid grid-cols-1 gap-y-2 my-auto">
          {/* <TextInput
            id="contact-us-name"
            type="text"
            placeholder="Name"
            widthClass="w-fit"
            onChange={() => {}}
          />
          <TextInput
            id="contact-us-email"
            type="text"
            placeholder="Email"
            widthClass="w-fit"
            onChange={() => {}}
          /> */}

          <Button
            bgColour="dark-grey"
            textColour="white"
            width="fit"
            paddingX="6"
            paddingY="2"
            className="h-fit"
            onClick={() => window.location.href = "/contact"}
          >
            <span className="">Make an enquiry</span>
          </Button>
        </div>

      </div>

      {/* Bubbles */}
      <img
        src="/img/graphics/bubbles/bubble-top-orange.svg"
        alt="Bubble"
        className="absolute w-32 md:w-48 object-cover -top-10 right-40"
      />
    </div>
  )
}
